import type { IconSvgObject } from './types';

const EarRings03Icon: IconSvgObject = [
  ["path", { d: "M3.5 7H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 4.5L5.5 4L8 6.99999L5.5 10L5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "17", cy: "7", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "7", cy: "17", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M20.5 17H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M19 14.5L18.5 14L16 17L18.5 20L19 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "5" }]
];

export default EarRings03Icon;
